import React, { useState, useRef } from 'react';
import _ from 'lodash';
import { useIntl } from 'react-intl';
import { GlobalButton as Button } from 'src/modules/global';
import { LayoutOverlay } from 'src/modules/layout';
import styles from './GlobalFormContact.module.scss';
import { GlobalFormContactProps } from './types';
import GlobalFormContactBody, { GlobalFormContactBodyControls } from './GlobalFormContactBody';

const GlobalFormContact: React.FunctionComponent<GlobalFormContactProps> = (
  props: GlobalFormContactProps
) => {
  const {
    buttonText,
    isOpen,
    fullWidth = true,
    title,
    confirmationTitleId = 'form/confirmationTitle',
    confirmationMessageId = 'form/confirmationSubline',
    onClose = _.noop,
  } = props;

  const [visible, setVisible] = useState(isOpen !== undefined ? isOpen : false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const intl = useIntl();
  const controls = useRef<GlobalFormContactBodyControls>();

  const handleClose = () => {
    if (controls.current.setCheckPolicy && controls.current.setSubmitClick) {
      controls.current.setCheckPolicy(false);
      controls.current.setSubmitClick(false);
    } else {
      console.error('GlobalFormContact: controls are not set');
    }
    setShowSuccessMessage(false);
    setVisible(false);
    onClose();
  };

  const getControls = (_controls: GlobalFormContactBodyControls) => {
    controls.current = _controls;
  };
  const onSubmit = (success: boolean) => {
    setShowSuccessMessage(success);
  };

  return (
    <div>
      {buttonText && (
        <Button onClick={() => setVisible(true)} widthType={fullWidth ? 'fullWidth' : 'halfWidth'}>
          {buttonText}
        </Button>
      )}

      <div className={styles.container}>
        <LayoutOverlay
          title={title || intl.formatMessage({ id: 'form/title' })}
          display={isOpen !== undefined ? isOpen : visible}
          onClose={handleClose}>
          <div className={styles.overlayBody}>
            {showSuccessMessage ? (
              <div className={styles.confirmation}>
                <h3>{intl.formatMessage({ id: confirmationTitleId })}</h3>
                <div>{intl.formatMessage({ id: confirmationMessageId })}</div>
                <Button type="primary" htmlType="submit" onClick={handleClose}>
                  {intl.formatMessage({ id: 'form/confirmationButtonClose' })}
                </Button>
              </div>
            ) : (
              <GlobalFormContactBody {...props} getControls={getControls} onSubmit={onSubmit} />
            )}
          </div>
        </LayoutOverlay>
      </div>
    </div>
  );
};

export default GlobalFormContact;
